import {StyledDayCell, StyledTodayIndicator} from '@/components/commons/calendar/day-cell/style'
import dayjs from 'dayjs'
import {DayProps, Matcher} from 'react-day-picker'

export const DayCell = ({warningDates, ...props}: DayProps & {warningDates?: Matcher | Matcher[]}) => {
    const isToday = props.modifiers.today
    const isOutside = props.modifiers.outside
    const isHightlightAvailabilities = props.modifiers.hightlightAvailabilitie
    const isStart = props.modifiers.range_start
    const isEnd = props.modifiers.range_end
    const isMiddle = props.modifiers.range_middle

    const formattedDay = dayjs(props.day.date).format('YYYY-MM-DD')
    const formattedWarningDates =
        warningDates && Array.isArray(warningDates)
            ? warningDates.map(day => dayjs(new Date(day as Date)).format('YYYY-MM-DD'))
            : warningDates
              ? [dayjs(props.day.date).format('YYYY-MM-DD')]
              : []

    return (
        <StyledDayCell
            {...props}
            $isOutside={props.modifiers.outside}
            $hightlightAvailabilities={isHightlightAvailabilities}
            $isStart={isStart}
            $isEnd={isEnd}
            $isMiddle={isMiddle}
            $isWarning={formattedWarningDates.includes(formattedDay)}
        >
            {props.children}
            {isToday && !isOutside && <StyledTodayIndicator className="today-indicator" />}
        </StyledDayCell>
    )
}
